import { useEffect, useState} from 'react'
import moment from 'moment'
import { BrowserRouter as Router } from 'react-router-dom'
import UnAuthView, { MobileUnAuthView } from './UnAuth'
import AuthView, { NoAuthEmailUsernameView, MobileAuthView, MobileNoAuthEmailUsernameView } from './Auth'
import Navbar from '../components/Desktop/Navbar'
import NavbarMobile from '../components/Mobile/Navbar'
import Footer from '../components/Desktop/Footer'
import FooterMobile from '../components/Mobile/Footer'
import { useCompleteSignIn } from '../hooks/authhooks'
import { useResource } from "../contexts/appcontext";
import AppPageSkeleton from '../components/AppPageSkeleton'
import { FilterType, SearchFilterOptionType } from "../data/types";
import Messages from '../components/Desktop/Messages'
import MessagesMobile from '../components/Mobile/Messages'
import { initializePendo } from '../utils/pendo';
import { getUIDFromAccessToken } from '../utils/helpers';
// import { FilterType, SearchFilterOptionType } from "../data/types";
import config from '../config';
// import NoEmailBanner from './NoEmailBanner'


var appStage = config?.env


const HomeCookRouter = () => {
  const { user, isLoadingUser, isFetchingUser, reloadUser } = useCompleteSignIn()
  const { globalFilter } = useResource();
  const [searchTerm, changeSearchTerm] = useState<string>("");
  const [currentFilter, setCurrentFilter] = useState<FilterType>(globalFilter);
  const [signInModalIsOpen, setSignInModalIsOpen] = useState(false);
  const [bootstrapComplete, setBootstrapComplete] = useState(false);

  const [messagesOpen, setMessagesOpen] = useState(false);
  const [messageCommunityId, setMessageCommunityId] = useState<string | undefined>();

  const loggedinUsername = user && user?.username ? user.username : "";
  const loggedinUid = user && user?.uid ? user.uid : "";

  const hasAccessToken = !!localStorage.getItem('accessToken');
  const isAuthenticated = !!(loggedinUid && loggedinUsername);
  const isResolvingSession =
    hasAccessToken &&
    !isAuthenticated &&
    (!bootstrapComplete || isLoadingUser || isFetchingUser);
  const showPageSkeleton = !bootstrapComplete || isResolvingSession;

  const [width, setWidth] = useState(window.innerWidth);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  const isMobile = width < 1440;

  useEffect(() => {
    let active = true;

    const bootstrapAuth = async () => {
      if (hasAccessToken) {
        await reloadUser();
      }
      if (active) {
        setBootstrapComplete(true);
      }
    };

    bootstrapAuth();

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(()=>{
    setCurrentFilter((user && user?.state)? {state: user.state, active: false, resourceType: "kitchen"} : globalFilter)
    
    var accountId = loggedinUsername ? `${appStage}_resource_pantry_signedup_users` : `${appStage}_resource_pantry_anonymous_users`
    var visitorId = loggedinUsername ? loggedinUsername : localStorage.getItem("visitorId")
    
    if (!visitorId){
      var login_token: any = localStorage.getItem('login_token')
      var token_uid: string = getUIDFromAccessToken(login_token)

      visitorId = (login_token && token_uid) ? token_uid : moment().format();
      accountId = (login_token && token_uid)  ? `${appStage}_resource_pantry_auth_users` : accountId

      localStorage.setItem("visitorId", visitorId as string || '')
    }

    if (visitorId && accountId) {
      initializePendo(visitorId, accountId);
    }
    // eslint-disable-next-line
  }, [user, loggedinUid, loggedinUsername])

  const searchFilterOptions: SearchFilterOptionType = {
    searchTerm,
    currentFilter,
    signInModalIsOpen,
    messagesOpen,
    messageCommunityId,
    changeSearchTerm,
    setCurrentFilter,
    setSignInModalIsOpen,
    setMessagesOpen,
    setMessageCommunityId,
  }

  return (
    <Router basename="/">
        {isMobile ? <NavbarMobile searchFilterOptions={searchFilterOptions} loading={showPageSkeleton} /> : <Navbar searchFilterOptions={searchFilterOptions} loading={showPageSkeleton} />}
        {
          (showPageSkeleton) ? (<AppPageSkeleton variant={isMobile ? 'mobile' : 'desktop'} />) : (
            (loggedinUid && loggedinUsername) ? ( 
              (isMobile) ? <MobileAuthView searchFilterOptions={searchFilterOptions} /> : <AuthView searchFilterOptions={searchFilterOptions} /> 
            ) : (
              (loggedinUid && !loggedinUsername) ? (
                (isMobile) ? <MobileNoAuthEmailUsernameView searchFilterOptions={searchFilterOptions} /> : <NoAuthEmailUsernameView searchFilterOptions={searchFilterOptions} />
              ) : (
                (isMobile) ? <MobileUnAuthView searchFilterOptions={searchFilterOptions} /> : <UnAuthView searchFilterOptions={searchFilterOptions} />
              )
            )
          )
        }
        {isMobile ? <MessagesMobile isOpen={messagesOpen} setIsOpen={setMessagesOpen} username={loggedinUsername} searchFilterOptions={searchFilterOptions} /> : <Messages isOpen={messagesOpen} setIsOpen={setMessagesOpen} username={loggedinUsername} searchFilterOptions={searchFilterOptions} />}
        {isMobile ? <FooterMobile /> : <Footer />}
    </Router>
    )
}



export default HomeCookRouter;

